import { useEffect, useState } from 'react';
import ModalSingleInput from '@components/ModalSingleInput';
import { useAuthentication } from '@context/businessContainer';
import useUpdateUserEmail from '@hooks/useUpdateUserEmail';
import { useRouter } from 'next/dist/client/router';
import { useTranslations } from 'next-intl';

const FillEmailModal = () => {
  const router = useRouter();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const updateUserEmail = useUpdateUserEmail();
  const { isAuthenticated, customer, isCustomerLoading } = useAuthentication();

  useEffect(() => {
    if (
      isAuthenticated &&
      !isCustomerLoading &&
      !['/account/register/flow', '/account/register-facebook-email'].includes(
        router.asPath.split('?')[0],
      )
    ) {
      setIsModalOpen(!customer?.email);
    } else {
      setIsModalOpen(false);
    }
  }, [isAuthenticated, router, customer]);

  const updateUserEmailHandler = (entry) => updateUserEmail(entry);

  const tGlobal = useTranslations('Global');
  const tAccount = useTranslations('Account');
  const tErrors = useTranslations('Errors');

  return (
    <>
      <ModalSingleInput
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        buttonLabel={tGlobal('validate')}
        cancelButtonLabel={tGlobal('cancel')}
        modalTitle={
          <h2 className="modal-title">{tAccount('noEmailAuthorization')}</h2>
        }
        inputLabel={
          <p className="input-label">
            {tAccount('couldNotGetEmail')}
            {' '}:
          </p>
        }
        inputPlaceholder=""
        submitHandler={updateUserEmailHandler}
        toastSuccessMessage={tAccount('emailUpdated')}
        toastErrorMessage={tErrors('emailUpdateError')}
        inputDefaultValue=""
        hasEmailValidation
        isClosable={false}
      />
      <style jsx>{`
        .modal-title {
          margin-bottom: var(--space-3);
          text-align: left;
        }
        @media (min-width: 555px) {
          .input-label {
            max-width: 60vw;
          }
        }
      `}</style>
    </>
  );
};

export default FillEmailModal;
